<template>
  <div class="main">
    <div class="header-block">
      <div class="header-banner"></div>
      <div class="header-arrow" @click="emits('goInvoice')">
        <el-icon><Back /></el-icon>
        <p class="title">开票信息维护</p>
      </div>
    </div>
    <div class="content">
      <div class="content-wrap">
        <p class="txt">开票信息维护</p>
        <div class="xt-list">
          <ul>
            <li class="xt-item" v-for="(item, index) in list" :key="index" @click="goForWard(item)">
              <div class="block_max">
                <img :src="item.url" :alt="item.name" />
                <div class="xt-content">
                  <p class="xt-label">{{ item.name }}</p>
                  <p class="xt-text">{{ item.text }}</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const emits = defineEmits(['goInvoice', 'changePage']);
const list = ref([
  {
    url: 'https://static.rhkj.com/renhe_fe/other/stateTax/folder_icon.png',
    key: 'maintence_spbm',
    name: '项目信息维护',
    text: '维护开票常用的商品信息和分类，支持批量导入导出项目信息',
  },
  {
    url: 'https://static.rhkj.com/renhe_fe/other/stateTax/user_icon.png',
    key: 'maintence_khbm',
    name: '客户信息维护',
    text: '维护开票常用的客户信息和分类，支持批量导入导出客户信息',
  },
  {
    url: 'https://static.rhkj.com/renhe_fe/other/stateTax/article_icon.png',
    key: '',
    name: '附加信息维护',
    text: '维护开票常用的场景模板与附加信息及其二者的关联，可快速应用于结构化备注信息的填写',
  },
]);

//跳转至下一页
function goForWard(data) {
  if (!data.key) {
    ElMessageBox.confirm('本系统为教学系统，暂不支持此功能', '信息', {
      showCancelButton: false,
      customStyle: {
        '--el-messagebox-width': '300px',
      },
    }).catch(() => {});
    return;
  }

  emits('changePage', data.key);
}
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  width: 100%;
  height: 100vh;
  background-color: #f6f7fb;
  .header-block {
    width: 100%;
    .header-banner {
      width: 100%;
      height: 0.64rem;
      background: #fff url('https://static.rhkj.com/renhe_fe/other/stateTax/head_log.png') no-repeat top / 100% 100%;
    }
    .header-arrow {
      width: inherit;
      height: 0.6rem;
      padding-left: 0.2rem;
      font-size: 0.18rem;
      background-color: #fff;
      display: flex;
      align-items: center;
      > .title {
        margin-inline-start: 10px;
        font-weight: 600;
        color: #333;
      }
    }
  }
  .content {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 0.2rem;
    background: #fff content-box;
    .content-wrap {
      box-sizing: border-box;
      width: 100%;
      padding: 0.2rem;
      .txt {
        width: 100%;
        height: 60px;
        line-height: 60px;
        font-size: 18px;
        color: #333;
        border-bottom: 1px solid #eee;
      }

      .xt-list {
        > ul {
          width: 100%;
          display: flex;
          column-gap: 20px;
          .xt-item {
            box-sizing: border-box;
            width: 354px;
            height: 134px;
            padding: 30px;
            border-radius: 3px;
            border: 1px solid #eee;
            .block_max {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              column-gap: 20px;
              cursor: pointer;
              img {
                width: 40px;
                aspect-ratio: 1;
                vertical-align: middle;
              }
              .xt-content {
                .xt-label {
                  font-size: 14px;
                  font-weight: 600;
                  color: #333;
                  line-height: 20px;
                }
                .xt-text {
                  font-size: 12px;
                  color: #666;
                  line-height: 20px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
